export const BalancosEnergeticotatusCssClasses = ["success", "info", ""];
export const BalancosEnergeticoituacao = ["Ativo", "Inativo"];
export const BalancoEnergeticoTipoPessoa = ["Pessoa Fisica", "Pessoa Juridica"];
export const BalancoEnergeticoConditionCssClasses = ["success", "danger", ""];
export const BalancoEnergeticoConditionTitles = ["New", "Used"];
export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "30", value: 30 },
  { text: "50", value: 50 },
  { text: "100", value: 100 }
];
export const initialFilter = {
  filter: {
    Cliente: null,
    DataVencimento: null,
    DataVencimentoAte: null,
    Fatura: null
  },
  sortOrder: "asc", // asc||desc
  sortField: "VINCode",
  pageNumber: 1,
  pageSize: 30
};
export const filtroNome="filtro.BalancoEnergetico";
